export default function bindMethods(object: object, context?: object) {
  context = context || object;

  for (const [key, value] of Object.entries(object)) {
    if (typeof value === 'function') {
      // @ts-ignore
      object[key] = value.bind(context);
    }
  }

  return object;
}
